import React from 'react';
import './index.scss';

const HeatMapKey: React.FC = () => {
  return (
    <>
      <div>
        <div className="heat_map_key_green"></div>
        <div className="heat_map_key_yellow_green"></div>
        <div className="heat_map_key_yellow"></div>
        <div className="heat_map_key_red"></div>
      </div>
      <div>
        <div className="heat_map_key_text">Top Quartile</div>
        <div className="heat_map_key_text">Median</div>
        <div className="heat_map_key_text">Bottom Quartile</div>
      </div>
    </>
  );
};

export default HeatMapKey;
